/* eslint-disable @next/next/no-img-element */
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { isEmpty } from 'lodash';

export default function EditorComponent({ text, classes, callback, title, content}) {
    const [display, setDisplay] = useState(false);

    const handleClose = () => setDisplay(false);
    const handleDisplay = () => setDisplay(true);

    const doCallBackAndOff = async () => {
        await callback();
        handleClose();
    };

    return <>
        <button className={classes} onClick={handleDisplay}>{text}</button>
        <Modal show={display} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{content}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Hủy
                </Button>
                <Button variant="primary" onClick={doCallBackAndOff}>
                    Xác nhận
                </Button>
            </Modal.Footer>
        </Modal>
    </>;
}
